import { createAri, type Ari } from '@atlassian/jira-platform-ari/src/index.tsx';

export const getBoardUrl = (projectKey: string, boardId: string, boardType: string) =>
	`/jira/software/${boardType === 'simple' ? '' : 'c/'}projects/${projectKey}/boards/${boardId}`;

export const getProductDiscoveryProjectUrl = (projectKey: string) =>
	`/jira/polaris/projects/${projectKey}/ideas`;

export const getViewUrl = (projectKey: string, viewSlug: string) =>
	`${getProductDiscoveryProjectUrl(projectKey)}/view/${viewSlug}`;

export const createProjectAri = (cloudId: string, projectId: string): Ari =>
	createAri({
		resourceOwner: 'jira',
		cloudId,
		resourceType: 'project',
		resourceId: projectId,
	});
